<template>
  <tr>
    <td class="number">
      <button @click="removeProduct">Usuń</button>
      {{ positionNumber }}.
    </td>
    <td>
      <editable block :id="`name-${_uid}`" :value="name" @change="name = $event"></editable>
    </td>
    <td class="number">
      <editable number :id="`quantity-${_uid}`" :value="quantity" @change="quantity = $event"></editable>
    </td>
    <td>
      <editable :id="`quantityType-${_uid}`" :value="quantityType" @change="quantityType = $event"></editable>
    </td>
    <td class="number">
      <editable money :id="`priceNetto-${_uid}`" :value="priceNetto" @change="priceNetto = $event"></editable>
    </td>
    <td class="number">
      <editable number :id="`vat-${_uid}`" :value="vat" @change="vat = $event"></editable>
    </td>
    <td class="number">{{ money(nettoValue)}}</td>
    <td class="number">{{ money(vatValue) }}</td>
    <td class="number">{{ money(bruttoValue) }}</td>
  </tr>
</template>

<script>
import accounting from 'accounting'
import Editable from 'components/Editable'

export default {
  props: ['product', 'index', 'positionNumber'],
  data () {
    return {
      name: this.product.name,
      quantity: this.product.quantity,
      quantityType: this.product.quantityType,
      priceNetto: this.product.priceNetto,
      vat: this.product.vat
    }
  },
  computed: {
    nettoValue () {
      return this.quantity * this.priceNetto
    },
    vatValue () {
      return this.nettoValue * this.vat / 100
    },
    bruttoValue () {
      return this.nettoValue + this.vatValue
    }
  },
  watch: {
    name (value) { this.changeProduct('name', value) },
    quantity (value) { this.changeProduct('quantity', value) },
    quantityType (value) { this.changeProduct('quantityType', value) },
    priceNetto (value) { this.changeProduct('priceNetto', value) },
    vat (value) { this.changeProduct('vat', value) },
    nettoValue (value) { this.changeProduct('nettoValue', value) },
    vatValue (value) { this.changeProduct('vatValue', value) },
    bruttoValue (value) { this.changeProduct('bruttoValue', value) }
  },
  methods: {
    money (value) {
      return accounting.formatNumber(value / 100, 2, '.', ',')
    },
    removeProduct () {
      this.$emit('remove', this.index)
    },
    changeProduct (key, value) {
      this.$emit('change', this.index, key, value)
    }
  },
  components: {
    Editable
  }
}
</script>

<style lang="scss" scoped>
@import "~assets/common.scss";

@media print {
  button {
    display: none !important;
  }
}
td,th {
  border-bottom: 1px solid $tableBackground;
  position: relative;
  padding: 0.4em;

  &.number {
    text-align: right;
  }
}
tr:last-child {
  td, th {
    border-bottom: 1px solid $tableBorder;
  }
}
button {
  @extend %canBeActive;
  display: inline;
  margin: -2pt;
  padding: 2pt;
  position: absolute;
  border: none;
  outline-style: none;
  left: -4em;
  width: 4em;

  &:focus {
    @extend %active;
  }
}
</style>



/** WEBPACK FOOTER **
 ** InvoiceRow.vue?f100556c
 **/